import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocationModel } from 'src/app/models/property.model';
import { LoadingService } from 'src/app/services/loading.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-mobile-popular-cities',
  templateUrl: './mobile-popular-cities.component.html',
  styleUrls: ['./mobile-popular-cities.component.css']
})
export class MobilePopularCitiesComponent implements OnInit {

  @Input() popularCities!: LocationModel[];
  placeholder: boolean = false;
  homeTexts: boolean = environment.homeTexts;

  constructor(
    private router: Router,
    private loadingService: LoadingService
  ) { }

  ngOnInit(): void {
    this.popularCities = this.popularCities.length == 3 ? this.popularCities.slice(0, 2) : this.popularCities.length > 4 ? this.popularCities.slice(0, 4) : this.popularCities.slice(0, 4);
    this.loadingService.placeholderValue.subscribe(value => {
      this.placeholder = value;
    });
  }

  searchByLocation(country: number, region: number, district: number, county: number | null = null) {
    const data = county && county !== null ? { country: country, region: region, district: district, county: county } : { country: country, region: region, district: district, }
    this.router.navigate(['/properties'], { queryParams: { location: JSON.stringify(data) } });
  }

  imageError(evt: Event) {
    const el = evt.target as HTMLImageElement;
    el.src = 'assets/images/not-found.png';
  }

}
